import { AideAgricoleStubPage } from '../../../../components/aides/AideAgricoleStubPage';
import { getAideAgricoleStub } from '../../../../config/aides-agriculteurs';

export default function CeeAgricolesPage() {
  const aide = getAideAgricoleStub('cee-agricoles');
  if (!aide) return null;
  return <AideAgricoleStubPage aide={aide} />;
}
